module.exports = __webpack_public_path__ + "img/card-3.53b08f9f.png";